/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-23",
    versionChannel: "nightly",
    buildDate: "2025-05-23T00:07:05.067Z",
    commitHash: "673df0f818988869563132346217196abfd4ea00",
};
